import React from 'react';
import { autobind } from 'core-decorators';

@autobind
class SliderTrack extends React.Component {
  render() {
    let props = this.props;
    let color = props.color;
    let y = props.y;
    let fromX = props.fromX;
    let toX = props.toX;
    let lineWidth = props.lineWidth;

    return <line x1={fromX} x2={toX} y1={y} y2={y} strokeWidth={lineWidth} stroke={color} strokeLinecap="round" />;
  }
}

export default SliderTrack;
